// warranty popup - am

window.onload = function(){

  setTimeout(warranty, 3250);

  function warranty(){

    var outerModal = document.getElementById("warranty-popup");
    // var modalOverlay = document.getElementById("modal-overlay");
    // var btn = document.getElementById("warranty-btn");   // trigger
    var btn = document.getElementsByClassName("spb-label-tooltip")[0];   // trigger
    var cursor = document.getElementsByClassName("spb-productdescfont")[0];


    if (btn != null){
      btn.classList.add('warranty-trigger');
      cursor.classList.add('warranty-trigger');

      btn.onclick = function() {
        outerModal.style.display = "flex";
        outerModal.classList.add("modal-open");
      }
    }


    document.addEventListener(
      "click",
      function(event) {

        // If clicks X button OR clicks outside the modal window, then close modal
        if (
          event.target.matches(".close-warranty-popup") ||
          event.target.matches("#modal-overlay")
        ) {
          closeModal()
        }
      },
      false
    )

    function closeModal() {
      if (outerModal != null) {
        outerModal.classList.remove("modal-open");
        outerModal.style.display = "none";
      }
    }

  }

}